// extracted by mini-css-extract-plugin
module.exports = {"alert":"AlertMessage_alert__Kvgx_","rotation":"AlertMessage_rotation__lfKoe"};